import type { PointDataSource } from '~/api/data-source/point';
import { pointDataSource } from '~/api/data-source/point';
import type { BuyerPoint } from '~/api/model';
import { buyerPointSchema, parseModel } from '~/api/model';

export interface PointRepository {
  getBuyerPoint(): Promise<BuyerPoint>;
}

export class PointRepositoryImpl implements PointRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: PointDataSource = pointDataSource) {}

  async getBuyerPoint() {
    const response = await this.dataSource.getBuyerPoint();
    return parseModel(buyerPointSchema, response, 'BuyerPoint');
  }
}

export const pointRepository = new PointRepositoryImpl();
